// Chat-specific @mention and #channel text-node highlighters.
// Extracted from renderMarkdown so the logic is testable in isolation.
// MarkdownPreview calls these when `withMentions: true`.

const _MENTION_RE = /@([a-zA-Z0-9._-]+)/g
const _CHANNEL_RE = /#([a-zA-Z0-9._-]+)/g

export const highlightMentions = (el, people) => {
  if (!el || !el.node) return
  const walker = document.createTreeWalker(el.node, NodeFilter.SHOW_TEXT)
  const replacements = []
  let textNode
  while ((textNode = walker.nextNode())) {
    _MENTION_RE.lastIndex = 0
    if (!_MENTION_RE.test(textNode.textContent)) continue
    replacements.push(textNode)
  }
  for (const node of replacements) {
    if (!node.parentNode) continue
    const frag = document.createDocumentFragment()
    let last = 0
    _MENTION_RE.lastIndex = 0
    let match
    while ((match = _MENTION_RE.exec(node.textContent)) !== null) {
      if (match.index > last) {
        frag.appendChild(document.createTextNode(node.textContent.slice(last, match.index)))
      }
      const local = match[1]
      const person = (people || []).find(p => p.email && p.email.split('@')[0].toLowerCase() === local.toLowerCase())
      if (!person) {
        frag.appendChild(document.createTextNode(match[0]))
      } else {
        const span = document.createElement('span')
        span.textContent = '@' + person.name
        span.style.cssText = 'color:var(--color-cyan,#66b2ff);font-weight:600;cursor:pointer;background:var(--color-cyan-a10,rgba(100,180,255,0.1));padding:1px 4px;border-radius:4px;'
        span.setAttribute('data-personrow', 'true')
        span.setAttribute('data-email', person.email)
        frag.appendChild(span)
      }
      last = match.index + match[0].length
    }
    if (last < node.textContent.length) {
      frag.appendChild(document.createTextNode(node.textContent.slice(last)))
    }
    node.parentNode.replaceChild(frag, node)
  }
}

export const highlightChannels = (el, channels) => {
  if (!el || !el.node) return
  const walker = document.createTreeWalker(el.node, NodeFilter.SHOW_TEXT)
  const replacements = []
  let textNode
  while ((textNode = walker.nextNode())) {
    _CHANNEL_RE.lastIndex = 0
    if (!_CHANNEL_RE.test(textNode.textContent)) continue
    replacements.push(textNode)
  }
  for (const node of replacements) {
    if (!node.parentNode) continue
    const frag = document.createDocumentFragment()
    let last = 0
    _CHANNEL_RE.lastIndex = 0
    let match
    while ((match = _CHANNEL_RE.exec(node.textContent)) !== null) {
      if (match.index > last) {
        frag.appendChild(document.createTextNode(node.textContent.slice(last, match.index)))
      }
      const name = match[1]
      const channel = (channels || []).find(c => c.name && c.name.toLowerCase() === name.toLowerCase())
      if (!channel) {
        frag.appendChild(document.createTextNode(match[0]))
      } else {
        const span = document.createElement('span')
        span.textContent = '#' + channel.name
        span.style.cssText = 'color:var(--color-cyan,#66b2ff);font-weight:600;cursor:pointer;background:var(--color-cyan-a10,rgba(100,180,255,0.1));padding:1px 4px;border-radius:4px;'
        span.setAttribute('data-channel-link', channel.id)
        frag.appendChild(span)
      }
      last = match.index + match[0].length
    }
    if (last < node.textContent.length) {
      frag.appendChild(document.createTextNode(node.textContent.slice(last)))
    }
    node.parentNode.replaceChild(frag, node)
  }
}
